import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

export const Text = styled.p<{ bottom?: boolean }>`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-style: italic;
  font-weight: 400;
  font-size: 11px;
  line-height: 10px;
  text-align: center;
  letter-spacing: -0.01em;

  color: ${(props) => props.theme.newPalette.neutral.N500};
  margin-bottom: ${(props) => (props.bottom ? '24px' : '6px')};
`;
